import NewsTipLink from './NewsTipLink'
export default NewsTipLink
